import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7435d3c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Search_Contents" }
const _hoisted_2 = { class: "Search_Contents_Title" }
const _hoisted_3 = { class: "Search_Contents_List" }

import { ref, watch } from "vue";
import InputText from "../atoms/Input/InputText.vue";
import ModalSyosiList from "../modal/ModalSyosiList.vue";
import { ZaikoData } from "@/types/zaiko";

// props
interface Props {
  // css調整用----------
  titleMinWidth?: string;
  titleMaxWidth?: string;
  listMinWidth?: string;
  inputNumWidth?: string;
  inputSyotenMeiWidth?: string;
  // -------------------
  title: string;
  initialData: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'searchInputSyosi',
  props: {
    titleMinWidth: {},
    titleMaxWidth: {},
    listMinWidth: {},
    inputNumWidth: {},
    inputSyotenMeiWidth: {},
    title: {},
    initialData: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "503d1aa4": (props.titleMaxWidth !== undefined?props.titleMaxWidth : '90px'),
  "18692fec": (props.titleMinWidth !== undefined?props.titleMinWidth : '90px'),
  "507f8bee": (props.listMinWidth !== undefined?props.listMinWidth : '224px'),
  "16185e19": (props.inputNumWidth !== undefined?props.inputNumWidth : '30%'),
  "1d5a72cd": (props.inputSyotenMeiWidth !== undefined?props.inputSyotenMeiWidth : '65%')
}))

const props = __props;
// emit
const emit = __emit;

const syosiData = ref({} as ZaikoData);
// 親データとの連携
watch(
  () => props.initialData,
  () => {
    syosiData.value.syosiCd = props.initialData;
  },
  { immediate: true, deep: true }
);

// モーダル開閉制御
const syosiModalVisible = ref(false);
// 書誌コードの手入力
const inputSyosiCd = (syosiCd: string) => {
  syosiData.value.syosiCd = syosiCd;
  emit("change", syosiData.value);
};
//書店選択を反映
const ref_selectSyosi = (selectedValue: ZaikoData): void => {
  syosiData.value = selectedValue;
  emit("change", syosiData.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (syosiModalVisible.value)
      ? (_openBlock(), _createBlock(ModalSyosiList, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (syosiModalVisible.value = false)),
          onRef_selectSyosi: ref_selectSyosi
        }))
      : _createCommentVNode("", true),
    _createElementVNode("li", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(InputText, {
          class: "Input_Yellow",
          onDblclick: _cache[1] || (_cache[1] = ($event: any) => (syosiModalVisible.value = true)),
          onOnInput: inputSyosiCd,
          value: syosiData.value.syosiCd,
          type: 'text',
          onkeydown: "return event.keyCode !== 69"
        }, null, 8, ["value"])
      ])
    ])
  ], 64))
}
}

})